<div class="content">
  <div class="container-fluid">
    <div class="page-title">
      <h1>Order Details</h1>
      <small class="float-right">
        <a routerLink="/purchase_history" class="back">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          Back</a>
      </small>
    </div>
    <div class="index-content">
      <!-- Detail -->
      <div class="content-detail order-detail">
        <div class="content-detail-header Completed">
          <h3>Order Number : {{orderNo}}</h3>
        </div>
        <div class="content-detail-body">
          <ul class="info">
            <li><span>Account</span>{{(user$ | async)?.currentUser}}</li>
            <li><span>Create Date</span>{{(createDate != 0) ? ((createDate * 1000) | date: 'yyyy/MM/dd') : '--'}} </li>
            <li><span>Status</span> {{(status != null) ? status : '--'}}</li>
          </ul>
          <p-dataTable #dt [value]="purchaseHistory">
            <p-column field="DeviceName" header="Node Name" [style]="{'width':'150px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.DeviceName != null) ? data.DeviceName : '--'}}
              </ng-template>
            </p-column>
            <p-column field="Model" header="Model Name" [style]="{'width':'150px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.Model != null) ? data.Model : '--'}}
              </ng-template>
            </p-column>
            <p-column field="NewLevel" header="Level" [style]="{'width':'150px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.NewLevel != null) ? (data.NewLevel) : '--'}}
              </ng-template>
            </p-column>
            <p-column field="PeriodExtend" header="Period Extend" [style]="{'width':'150px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.PeriodExtend != null) ? (data.PeriodExtend | numToDate) : '--'}}
              </ng-template>
            </p-column>
            <p-column field="PreviousExpiredDate" header="Previous Expired Date" [style]="{'width':'180px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.PreviousExpiredDate != null) ? ((data.PreviousExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
              </ng-template>
            </p-column>
            <p-column field="NewExpiredDate" header="New Expired Date" [style]="{'width':'180px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.NewExpiredDate != null) ? ((data.NewExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
              </ng-template>
            </p-column>
            <p-column field="AmountPaid" header="Amount Paid" [style]="{'width':'170px'}" styleClass="col-nowrap">
              <ng-template let-col let-data="rowData" pTemplate="body">
                {{(data.AmountPaid != null) ? data.AmountPaid : '--'}}
              </ng-template>
            </p-column>
            <ng-template pTemplate="emptymessage">
              No Data found
            </ng-template>
          </p-dataTable>
          <p-table class="deviceTable" #dt [columns]="purchaseHistory_cols" [value]="purchaseHistory" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]"
                   [scrollable]="true">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr>
                <td style="width:150px" class="col-nowrap">
                    {{(rowData.DeviceName != null) ? rowData.DeviceName : '--'}}
                </td>
                <td style="width:150px" class="col-nowrap">
                    {{(rowData.Model != null) ? rowData.Model : '--'}}
                </td>
                <td style="width:150px" class="col-nowrap">
                    {{(rowData.NewLevel != null) ? (rowData.NewLevel) : '--'}}
                </td>
                <td style="width:150px" class="col-nowrap">
                    {{(rowData.PeriodExtend != null) ? (rowData.PeriodExtend | numToDate) : '--'}}
                </td>
                <td style="width:180px" class="col-nowrap">
                    {{(rowData.PreviousExpiredDate != null) ? ((rowData.PreviousExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
                </td>
                <td style="width:180px" class="col-nowrap">
                    {{(rowData.NewExpiredDate != null) ? ((rowData.NewExpiredDate * 1000) | date: 'yyyy/MM/dd') : ''}}
                </td>
                <td style="width:170px" class="col-nowrap">
                    {{(rowData.AmountPaid != null) ? rowData.AmountPaid : '--'}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="purchaseHistory_cols.length">
                  <div translate class="ui-emptymessage">No Data found</div>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="totalPaid">
            <p>Total Amount Paid</p>
            <p class="price_num">${{totalAmountPaid}}<small>{{currencyCode}}</small></p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
